import React from 'react';
import { Link } from 'react-router-dom';

const SUPPORT_EMAIL = 'support@leadmarka.co.zw';

const LegalFooter = ({ className = '', openInNewTab = false }) => {
  const linkProps = openInNewTab ? { target: '_blank', rel: 'noopener noreferrer' } : {};
  return (
    <div className={`text-center text-xs text-gray-500 ${className}`.trim()}>
      <p>
        Need help?{' '}
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="inline-flex items-center justify-center text-primary-600 hover:text-primary-700 font-medium"
        >
          {SUPPORT_EMAIL}
        </a>
      </p>
      <div className="mt-2 flex items-center justify-center gap-3">
        <Link
          to="/terms"
          {...linkProps}
          className="inline-flex items-center justify-center text-gray-500 hover:text-gray-700"
        >
          Terms
          {openInNewTab && <span className="sr-only"> (opens in a new tab)</span>}
        </Link>
        <span className="text-gray-300">•</span>
        <Link
          to="/privacy"
          {...linkProps}
          className="inline-flex items-center justify-center text-gray-500 hover:text-gray-700"
        >
          Privacy
          {openInNewTab && <span className="sr-only"> (opens in a new tab)</span>}
        </Link>
        <span className="text-gray-300">•</span>
        <a
          href="/privacy#data-deletion"
          {...linkProps}
          className="inline-flex items-center justify-center text-gray-500 hover:text-gray-700"
        >
          Data deletion
          {openInNewTab && <span className="sr-only"> (opens in a new tab)</span>}
        </a>
      </div>
    </div>
  );
};

export default LegalFooter;
